enum MarketExpansionLineOfBusinessEnum {
  Medicare = 1,
  Medicaid = 2,
  Marketplace = 3,
}

export { MarketExpansionLineOfBusinessEnum };
